// extracted by mini-css-extract-plugin
module.exports =  {"container":"skills_report-module_container_f70fd","item":"skills_report-module_item_bf8dd"};